export const blockIconsCommunicationLocationOn = (
	<span className='material-symbols-outlined'>location_on</span>
);
